export const resolveDirectionFromPaths = (oldPath, newPath, { flowConfig, basePath }) => {
  const configPaths = flowConfig.steps.map(step => step.path);

  const regExp = new RegExp(`${basePath}\\/?`);
  const oldConfigPath = oldPath.replace(regExp, '');
  const newConfigPath = newPath.replace(regExp, '');

  const oldPathIndex = configPaths.indexOf(oldConfigPath);
  const newPathIndex = configPaths.indexOf(newConfigPath);

  if (oldPathIndex > -1 && newPathIndex > -1) {
    return oldPathIndex < newPathIndex ? 'next' : 'back';
  }

  // Special case when visitng the start page with URL /signup
  if (newConfigPath === '') {
    return 'back';
  }

  return 'next';
};
